import { Check } from 'lucide-react'
import { useState } from 'react'

import { IllustrationName } from '@/components/icons/Illustration'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import { cn } from '../../lib/utils'
import { ChatActionWithValue } from '../../models/insuranceApplication'
import { Esign } from '../Esign'
import { IllustratedRow } from './ConfirmInfoCard'

interface ChatSignAgreementProps {
  isSigned?: boolean
  envelopeId?: string
  label: string
  handleSubmit: (data: ChatActionWithValue | FormData) => void
  readonly?: boolean
}

export function ChatSignAgreement({
  handleSubmit,
  isSigned,
  label,
  envelopeId,
  readonly: _readonly,
}: ChatSignAgreementProps) {
  const [isOpen, setIsOpen] = useState(false)

  function onSubmit() {
    setIsOpen(false)
    handleSubmit({
      content: {
        component: 'SIGN_AGREEMENT',
        props: { is_signed: true, label },
      },
      value: 'value',
    })
  }

  function onCancel() {
    setIsOpen(false)
  }

  return (
    <>
      <div
        className={cn(
          'mt-6 flex w-full cursor-pointer items-center justify-end gap-2 font-semibold',
          isSigned && 'cursor-auto opacity-50'
        )}
        onClick={isSigned ? undefined : () => setIsOpen(true)}
      >
        <Card className="w-full">
          <CardContent>
            <IllustratedRow
              illustration={IllustrationName.BOR}
              label={label}
              action={
                isSigned ? (
                  <div className="flex gap-1 text-green-600">
                    <Check />
                    Signed
                  </div>
                ) : (
                  <Button>Sign</Button>
                )
              }
            />
          </CardContent>
        </Card>
      </div>

      <Dialog open={isOpen} onOpenChange={onCancel}>
        <DialogContent size="full" className="h-[calc(100vh-40px)] max-h-[calc(100vh-40px)] content-stretch">
          <Esign title={label} envelopeId={envelopeId} onSign={onSubmit} />
        </DialogContent>
      </Dialog>
    </>
  )
}
